'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dragDropContext = require('./drag-drop-context');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dragDropContext).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/drag-drop-context/index.js
// module id = 2962
// module chunks = 0